import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appPhoneMask]'
})
export class PhoneMaskDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let value = this.el.nativeElement.value.replace(/\D/g, '');
    
    // Maksimum 11 karakter (0 ile başlayan Türkiye numarası)
    if (value.length > 11) {
      value = value.substring(0, 11);
    }

    let formattedValue = '';
    
    if (value.length > 0) {
      // İlk rakam 0 değilse 0 ekle
      if (value[0] !== '0') {
        value = '0' + value;
      }
      
      formattedValue = value[0]; // "0"
      
      if (value.length > 1) {
        formattedValue += '(' + value.substring(1, Math.min(4, value.length));
        
        if (value.length >= 4) {
          formattedValue += ')';
          
          if (value.length > 4) {
            formattedValue += ' ' + value.substring(4, Math.min(7, value.length));
            
            if (value.length > 7) {
              formattedValue += ' ' + value.substring(7, Math.min(9, value.length));
              
              if (value.length > 9) {
                formattedValue += ' ' + value.substring(9, 11);
              }
            }
          }
        }
      }
    }
    
    this.el.nativeElement.value = formattedValue;
    
    // FormControl'ü güncelle
    const inputEvent = new Event('input', { bubbles: true });
    this.el.nativeElement.dispatchEvent(inputEvent);
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any) {
    // Blur'da temiz değeri geri döndür (sadece rakamlar)
    let value = this.el.nativeElement.value.replace(/\D/g, '');
    
    // FormControl'e sadece rakamları kaydet
    if (this.el.nativeElement.value !== value) {
      this.el.nativeElement.value = value;
      const inputEvent = new Event('input', { bubbles: true });
      this.el.nativeElement.dispatchEvent(inputEvent);
    }
  }

  @HostListener('focus', ['$event'])
  onFocus(event: any) {
    // Focus'ta formatlanmış değeri göster
    let value = this.el.nativeElement.value.replace(/\D/g, '');
    this.formatAndDisplay(value);
  }

  private formatAndDisplay(value: string) {
    if (value.length > 11) {
      value = value.substring(0, 11);
    }

    let formattedValue = '';
    
    if (value.length > 0) {
      if (value[0] !== '0') {
        value = '0' + value;
      }
      
      formattedValue = value[0];
      
      if (value.length > 1) {
        formattedValue += '(' + value.substring(1, Math.min(4, value.length));
        
        if (value.length >= 4) {
          formattedValue += ')';
          
          if (value.length > 4) {
            formattedValue += ' ' + value.substring(4, Math.min(7, value.length));
            
            if (value.length > 7) {
              formattedValue += ' ' + value.substring(7, Math.min(9, value.length));
              
              if (value.length > 9) {
                formattedValue += ' ' + value.substring(9, 11);
              }
            }
          }
        }
      }
    }
    
    this.el.nativeElement.value = formattedValue;
  }
}
